module.exports = __webpack_public_path__ + "img/logo-ecovie.7fdd5ce8.png";